import React from 'react';
import LegalDocumentPage from '../LegalDocumentPage/LegalDocumentPage';
import {LICENSE_AGREEMENT_CONTENT} from '../../../configs/legal/licenseAgreement';

function LicenseAgreementPage({onBack}) {
  return (
    <LegalDocumentPage
      pageId="LicenseAgreementPage"
      content={LICENSE_AGREEMENT_CONTENT}
      onBack={onBack}
    />
  );
}

export default LicenseAgreementPage;
